// Contexto de transferências

import React, { createContext, useState, useContext } from 'react';

const TransferContext = createContext();

export function TransferProvider({ children }) {
  const [transfers, setTransfers] = useState([]);
  const [currentTransfer, setCurrentTransfer] = useState(null);

  const createTransfer = (transferData) => {
    const newTransfer = {
      id: Date.now(),
      timestamp: new Date(),
      status: 'pending',
      ...transferData,
    };
    setTransfers([...transfers, newTransfer]);
    setCurrentTransfer(newTransfer);
    return newTransfer;
  };

  const updateTransfer = (id, updates) => {
    setTransfers(transfers.map(t => t.id === id ? { ...t, ...updates } : t));
  };

  const confirmTransfer = (id) => {
    updateTransfer(id, { status: 'confirmed' });
  };

  const completeTransfer = (id) => {
    updateTransfer(id, { status: 'completed', completedAt: new Date() });
  };

  const cancelTransfer = (id) => {
    updateTransfer(id, { status: 'cancelled' });
  };

  const getTransfer = (id) => {
    return transfers.find(t => t.id === id);
  };

  const getTransfersHistory = () => {
    return transfers.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
  };

  return (
    <TransferContext.Provider value={{
      transfers,
      currentTransfer,
      setCurrentTransfer,
      createTransfer,
      updateTransfer,
      confirmTransfer,
      completeTransfer,
      cancelTransfer,
      getTransfer,
      getTransfersHistory,
    }}>
      {children}
    </TransferContext.Provider>
  );
}

export function useTransfers() {
  const context = useContext(TransferContext);
  if (!context) {
    throw new Error('useTransfers deve ser usado dentro de TransferProvider');
  }
  return context;
}
